import {
  DEFAULT_DAILY_RULE,
  type Category,
  type Entry,
  type MatrixDocument,
  type Operation,
  type Outcome,
  type RepeatRule,
} from '../../packages/domain/src/index'

export const FIXTURE_OWNER_ID = 'synthetic-owner'
export const FIXTURE_TODAY = '2026-08-19'

const activePeriods = [{ from: '2026-08-01', toExclusive: null }] as const

function rule(id: string, repeatRule: RepeatRule = DEFAULT_DAILY_RULE) {
  return [{ id, effectiveFrom: '2026-08-01', rule: repeatRule }]
}

export const fixtureCategories: Category[] = [
  { id: 'clarity', name: 'Clarity & balance', activePeriods, operationOrder: ['meditation', 'journal'] },
  { id: 'fuel', name: 'Fuel', activePeriods, operationOrder: ['green-drink', 'yakult'] },
  { id: 'home', name: 'Home refuge', activePeriods, operationOrder: ['beds', 'washing'] },
]

export const fixtureOperations: Operation[] = [
  { id: 'meditation', categoryId: 'clarity', name: 'Meditation', private: false, activePeriods, ruleVersions: rule('meditation-rule') },
  {
    id: 'journal', categoryId: 'clarity', name: 'Journal', private: true, activePeriods,
    ruleVersions: rule('journal-rule', { quota: 3, weekdays: null, period: { kind: 'week' }, part: { kind: 'whole' } }),
  },
  { id: 'green-drink', categoryId: 'fuel', name: 'Green drink', private: false, activePeriods, ruleVersions: rule('green-rule') },
  { id: 'yakult', categoryId: 'fuel', name: 'Yakult', private: false, activePeriods, ruleVersions: rule('yakult-rule') },
  { id: 'beds', categoryId: 'home', name: 'Beds made', private: false, activePeriods, ruleVersions: rule('beds-rule') },
  {
    id: 'washing', categoryId: 'home', name: 'Washing', private: true, activePeriods,
    ruleVersions: rule('washing-rule', { quota: 1, weekdays: null, period: { kind: 'rolling', days: 2 }, part: { kind: 'whole' } }),
  },
]

const outcomes: readonly Outcome[] = ['T', 'W', 'C', 'B']

function fixtureEntries(): Entry[] {
  const entries: Entry[] = []
  for (let day = 1; day <= 19; day += 1) {
    const date = `2026-08-${String(day).padStart(2, '0')}`
    fixtureOperations.forEach((operation, operationIndex) => {
      const marker = day + operationIndex
      if (marker % 5 === 0 || (operation.id === 'washing' && marker % 2 === 0)) return
      entries.push({ operationId: operation.id, date, outcome: outcomes[marker % outcomes.length] })
    })
  }
  // M exists only because this synthetic row represents an imported legacy value.
  const importedIndex = entries.findIndex((entry) => entry.operationId === 'meditation' && entry.date === '2026-08-03')
  if (importedIndex >= 0) entries.splice(importedIndex, 1)
  entries.push({ operationId: 'meditation', date: '2026-08-03', outcome: 'M' })
  return entries
}

export function createFixtureDocument(): MatrixDocument {
  return {
    ownerId: FIXTURE_OWNER_ID,
    categories: fixtureCategories,
    operations: fixtureOperations,
    entries: fixtureEntries(),
    target: 80,
  }
}
